import AbstractViewManage from '@/class/view/AbstractViewManage'
import { deleteFile, getFileList } from '@/api/storage'
import { cache, cacheName } from '@/utils/cacheManager'
import { sortByMultiField } from '@/utils'
import URL from '@/api/urlTranslator'
import { getDocCategoryTypeTreeByLob } from '@/api/sysManage/baseConfig/docCategory'

export default class FileHistoryHp extends AbstractViewManage {
  constructor(view) {
    super(view)
    cache.load(cacheName.CONFIG).then(() => {
      this.config = cache.config
    })
  }

  get view() {
    return this._view
  }

  set view(value) {
    this._view = value
  }

  async init() {
    await getDocCategoryTypeTreeByLob({ constructLobParent: false, lob: this.view.file.cloudFile.lob }).then(res => {
      res.data.forEach(item => {
        if (item.type === 2) {
          this.view.file.fileTypeMap.set(item.code.toUpperCase(), item.chineseName)
          this.view.file.docType.push(item)
        }
      })
    })
    this.toFileQuery()
  }

  // 文件信息查询
  toFileQuery() {
    console.log('this:', this)
    this.view.file.storageURL = this.config.get('StorageURL')
    const xmlParam = '<RequestObject><data><extendMetaData><entry><key>' + this.view.file.queryKey + '</key><value>' +
        this.view.fileCloudFileJob.uuid +
        '</value></entry></extendMetaData></data></RequestObject>'
    getFileList(xmlParam).then(res => {
      const resData = Array.from(res.data, p => {
        return {
          fileId: p.id,
          fileName: p.fileName,
          fileType: p.extendMetaData.documentType || '',
          fileFormat: p.fileType.split(';')[0],
          fileSize: p.fileSize,
          fileVersion: p.fileVersion || '',
          createDate: p.createDate,
          createChineseName: p.extendMetaData.createChineseName || '',
          createdBy: p.extendMetaData.createdBy,
          extendMetaData: p.extendMetaData,
          fileNameBak: p.fileName,
          path: '',
          hasParent: false,
          parentId: ''
        }
      })
      this.getFilesSucceedHandler(resData)
    })
  }

  // 文件列表 父级和子级组装
  getFilesSucceedHandler(resData) {
    // 排序后放入临时对象数据
    const rowDataTempt = sortByMultiField(resData, ['fileName', 'fileVersion', 'createDate'], true)
    if (!rowDataTempt || rowDataTempt.length === 0) {
      return
    }
    let fatherFile = rowDataTempt[0]
    // 初始化 首个父节点的path
    fatherFile.path = fatherFile.fileId
    fatherFile.hasParent = false
    const source = []
    source.push(fatherFile)
    let childFile
    for (let i = 1; i < rowDataTempt.length; i++) {
      childFile = rowDataTempt[i]
      childFile.hasParent = false
      if (childFile.fileName === fatherFile.fileName) {
        if (fatherFile.hasParent) {
          childFile.path = fatherFile.parentId + ',' + childFile.fileId
          childFile.hasParent = true
          childFile.parentId = fatherFile.parentId
        } else {
          childFile.path = fatherFile.fileId + ',' + childFile.fileId
          childFile.hasParent = true
          childFile.parentId = fatherFile.fileId
        }
      } else {
        // 遍历到父节点了
        childFile.path = childFile.fileId
      }
      source.push(childFile)
      fatherFile = childFile
    }
    // 数据组装后 父级再次排序 根据createDate fileName
    let parentFileList = source.filter(val => {
      return val.hasParent === false
    })
    const childFileList = source.filter(val => {
      return val.hasParent === true
    })
    parentFileList = sortByMultiField(parentFileList, ['createDate', 'fileName'], true)

    const fileList = [...parentFileList, ...childFileList]
    this.view.file.rowData = fileList
  }

  // 文件删除
  fileRemove() {
    const rows = this.view.file.gridApi.getSelectedRows()
    // if (rows.length === 0) {
    //   this.view.$message.warning(this.view.$t('CargoMsg.Cargo_PleaseSelectFile'))
    //   return
    // }
    const fileDeleteRole = this.view.$checkPermission(['button_FileHistory_fileDelete'])
    const ownFileDeleteRole = this.view.$checkPermission(['role_FileDownloads_ownFileDelete'])
    for (const item of rows) {
      if (!fileDeleteRole && ownFileDeleteRole) {
        if (!item.extendMetaData || (this.view.$store.getters.userId !== Number(item.extendMetaData.createdBy))) {
          this.view.$message.warning(this.view.$t('CargoMsg.Cargo_OwnFileDelete'))
          return
        }
      }
    }
    this.view.$confirm(this.view.$t('CargoMsg.Cargo_AYSDF'), this.view.$t('common.tips.prompt'), {
      confirmButtonText: this.view.$t('common.btn.ok'),
      cancelButtonText: this.view.$t('common.btn.cancel'),
      closeOnClickModal: false,
      type: 'warning'
    }).then(async() => {
      let count = 0
      try {
        for (const item of rows) {
          const isSuccess = await deleteFile(item.fileId).then(res => res.data === 'success')
          if (isSuccess) {
            count++
            item.isDeleted = true
          } else {
            count = 0
            this.view.$message.error(this.view.$t('CargoMsg.Cargo_ERF'))
            break
          }
        }
      } finally {
        if (count > 0) this.view.$message.success(this.view.$t('CargoMsg.Cargo_FDS'))
        this.view.file.rowData = this.view.file.rowData.filter(p => !p.isDeleted)
      }
    }).catch(() => { })
  }

  // 批量下载
  fileDownload() {
    const rows = this.view.file.gridApi.getSelectedRows()
    if (!rows || rows.length === 0) {
      this.view.$message.warning(this.view.$t('CargoMsg.Cargo_SelectFilesToDownload'))
      return
    }
    // 判断是否有权限
    if (!this.validate(rows)) {
      return
    }
    if (rows.length === 1) {
      window.open(`${URL.common.findByFileId}/${rows[0].fileId}?sessionId=${this.view.$store.getters.userInfo.sessionId}`)
    } else {
      const fileIds = Array.from(rows, p => p.fileId).reduce((a, b) => a + ',' + b)
      const fileName = this.view.fileCloudFileJob.uuid + '.zip'
      window.open(`${URL.common.compressFiles}?sessionId=${this.view.$store.getters.userInfo.sessionId}&fileIds=${fileIds}&fileName=${fileName}`)
    }
  }

  // 校验
  validate(fileList) {
    if (!this.view.$checkPermission(['button_FileHistory_fileDownloads'])) {
      if (!fileList || fileList.length <= 0) return true
      for (const file of fileList) {
        if (!this.checkDownloadFile(file)) {
          return false
        }
      }
    }
    if (!fileList || fileList.length <= 0) return true
    for (const file of fileList) {
      if (file.extendMetaData.hasOwnProperty('documentType')) {
        return this.checkFileDocTypeRole(file)
      }
    }
    return true
  }

  checkFileDocTypeRole(data) {
    let documentType = data.extendMetaData.documentType
    if (documentType === this.view.$t('Message.Other')) {
      documentType = 'OTHER'
    }
    if (documentType === 'other' || documentType === 'Other') {
      documentType = documentType.toLocaleUpperCase()
    }
    const result = this.getDocType(documentType)
    if (!result || result.length === 0) {
      return true
    }

    if (this.view.$store.getters.isAdmin || parseInt(data.createdBy) === this.view.$store.getters.userId) {
      return true
    }

    const fileRoleMap = this.getFileRoleMap(result)
    if (fileRoleMap.length === 0) {
      this.view.$message.warning(this.view.$t('SeaExport.FileNotAllowedView').replace('{0}', data.fileName))
      return false
    }
    let isView = false
    if (this.view.$checkPermission(['role_sales']) && fileRoleMap.indexOf('sales') !== -1) {
      isView = true
    }
    if (this.view.$checkPermission(['role_op']) && fileRoleMap.indexOf('op') !== -1) {
      isView = true
    }
    if (!isView && fileRoleMap.indexOf('all') !== -1) {
      isView = true
    }
    if (!isView) {
      this.view.$message.warning(this.view.$t('SeaExport.NoPermissionToView').replace('{0}', data.fileName))
      return
    }
    return true
  }

  // 获取code所关联的XML 原cargo getDocTypeXml
  getDocType(codes) {
    const docTypeFilter = []
    if (codes == null || codes === '') {
      return null
    }
    const codeArray = codes.split(',')
    for (let i = 0; i < codeArray.length; i++) {
      const docObject = this.view.file.docType.find(x => x.code === codeArray[i])
      if (docObject != null) {
        docTypeFilter.push(docObject)
      }
    }
    return docTypeFilter
  }

  //  文档属性权限
  getFileRoleMap(result) {
    const fileRoleMap = []
    if (this.getDocTypeRole('sales', result)) {
      fileRoleMap.push('sales')
    }
    if (this.getDocTypeRole('op', result)) {
      fileRoleMap.push('op')
    }
    if (this.getDocTypeRole('all', result)) {
      fileRoleMap.push('all')
    }
    return fileRoleMap
  }

  // 获取 获取属性访问权限
  getDocTypeRole(roleKey, docType) {
    if (docType === null || docType.length === 0) {
      return false
    }
    if (roleKey === 'all') {
      roleKey = 'other'
    }
    for (let i = 0; i < docType.length; i++) {
      if (docType[i][roleKey]) {
        return true
      }
    }

    return false
  }

  // 发送邮件
  fileSendEmail() {
    const rows = this.view.file.gridApi.getSelectedRows()
    if (rows.length === 0) {
      this.view.$message.warning(this.view.$t('Message.PleaseSelectAFileToDownloadOrSend'))
      return
    }

    this.view.file.sendEmailDialog.visible = true
    this.view.file.sendEmailDialog.emailTitle = Array.from(rows, p => p.fileName).reduce((a, b) => a + ';' + b)
    this.view.file.sendEmailDialog.fileIdList = Array.from(rows, p => p.fileId).reduce((a, b) => a + ',' + b)
    this.view.file.sendEmailDialog.fileList = rows
  }

  // 查看详情
  popFileHistoryDetailFormDialog(value) {
    this.view.file.isShowingDetailForm = true
    const fileObject = this.view.file.rowData.find(x => x.fileId === value)
    const extendMetaData = fileObject.extendMetaData
    this.view.file.showDetailTitle = fileObject.fileName + '_' + fileObject.fileVersion

    const roles = ['op', 'sales', 'all', 'customer', 'consignee', 'shipper', 'destinationAgent', 'bookingAgent']

    let docTypeFilter = null
    // 文件类型转换
    if (extendMetaData.hasOwnProperty('documentType')) {
      let documentType = extendMetaData.documentType
      if (documentType === this.view.$t('Message.Other')) {
        documentType = 'OTHER'
      }
      if (documentType === 'other' || documentType === 'Other') {
        documentType = documentType.toLocaleUpperCase()
      }
      //  根据文件类型code 获取相关属性
      docTypeFilter = this.getDocType(documentType)
    }

    const extendMetaDataSort = this.objKeySort(extendMetaData)
    const tempFileDetailList = []
    for (const key in extendMetaDataSort) {
      if (key === 'entry' || key === 'createdBy') {
        continue
      }
      let keyValue
      if (roles.includes(key) && docTypeFilter != null) {
        keyValue = this.getDocTypeRole(key, docTypeFilter) ? this.view.$t(`SeaExport.Accessible`) : ''
      } else {
        keyValue = extendMetaData[key]
      }
      const convertKeyName = this.keyLabFunc(key)

      let keyName = this.view.$t(`SeaExport.${convertKeyName}`)
      if (keyName === 'SeaExport.') {
        keyName = key
      }
      /* 资源文件未转义 特殊处理直接赋值*/
      if (keyName === 'SeaExport.bookingAgent') {
        keyName = this.view.$t('SeaExport.BookingAgent')
      }
      const json = { 'key': keyName, 'val': keyValue }
      tempFileDetailList.push(json)
    }
    this.view.file.rowDataFileDetail = tempFileDetailList
  }

  // 查看详情
  onFileView(value) {
    const fileObject = this.view.file.rowData.find(x => x.fileId === value)
    // 判断是否有下载文件的权限
    if (!this.view.$checkPermission(['button_FileHistory_fileDownloads'])) {
      if (!this.checkDownloadFile(fileObject)) {
        return
      }
    }
    // 检查文件查询权限
    if (fileObject.extendMetaData.hasOwnProperty('documentType')) {
      if (!this.checkFileDocTypeRole(fileObject)) {
        return
      }
    }
    const url = `${URL.common.findByFileId}/${value}?sessionId=${this.view.$store.getters.userInfo.sessionId}`
    window.open(url)
  }

  checkDownloadFile(data) {
    if (Number(data.createdBy) !== this.view.$store.getters.userId) {
      this.view.$message.warning(this.view.$t('SeaExport.NoPermissionToViewOrprinted'))
      return false
    }
    return true
  }

  // json 根据 key 的名称排序的函数
  objKeySort(obj) {
    const newKey = Object.keys(obj).sort()
    const newObj = {}
    for (let i = 0; i < newKey.length; i++) {
      newObj[newKey[i]] = obj[newKey[i]]
    }
    return newObj
  }

  // 转换对应的 中文定义的keyName
  keyLabFunc(value) {
    let convertKeyName = ''
    switch (value) {
      case 'op':
        convertKeyName = 'Operation'
        break
      case 'sales':
        convertKeyName = 'Sales'
        break
      case 'all':
        convertKeyName = 'AllPositions'
        break
      case 'customer':
        convertKeyName = 'ConsignationCompany'
        break
      case 'consignee':
        convertKeyName = 'Consignee'
        break
      case 'shipper':
        convertKeyName = 'Shipper'
        break
      case 'destinationAgent':
        convertKeyName = 'DestinationAgent'
        break
      case 'bookingAgent':
        convertKeyName = 'bookingAgent'
        break
    }
    return convertKeyName
  }

  static onFileTypeCellFocused(event, view) {
    if (event.column && event.column && event.column.colId === 'fileType') {
      if (!view.$store.getters.isAdmin) {
        if (Number(view.file.rowData[event.rowIndex].createdBy) !== view.$store.getters.userId) {
          return
        }
      }
      this.fileTypeEdit(view.file.rowData[event.rowIndex])
    }
  }

  static fileTypeEdit(data, view) {
    view.file.fileTypeEditor.fileId = data.fileId
    view.file.fileTypeEditor.fileCategory = data.fileType
    view.file.fileTypeEditor.visible = true
  }

  // 转换文件类型中文名称
  static fileTypeLabelFunction(value, view) {
    if (!value) return view.$t('Message.Other')
    let returnVal = ''
    const codes = value.split(',')
    for (let i = 0; i < codes.length; i++) {
      if (returnVal === '') {
        returnVal = view.file.fileTypeMap.get(codes[i]) || view.$t('Message.Other')
      } else {
        returnVal = returnVal + ',' + (view.file.fileTypeMap.get(codes[i]) || view.$t('Message.Other'))
      }
    }
    return returnVal
  }

  // 文件大小转换
  static fileSizeColumnLabel(value) {
    if (value !== '' && !isNaN(value)) {
      return (value / 1024).toFixed(2) + ' KB'
    }
    return ''
  }
}
